"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Space, null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Default size card",
    extra: /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "More"),
    style: {
      width: 300
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, "Card content"), " ", /*#__PURE__*/_react.default.createElement("p", null, "Card content"), " ", /*#__PURE__*/_react.default.createElement("p", null, "Card content")), /*#__PURE__*/_react.default.createElement(_antd.Card, {
    loading: true,
    size: "small",
    title: "Small size card",
    extra: /*#__PURE__*/_react.default.createElement("a", {
      href: "#"
    }, "More"),
    style: {
      width: 300
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, "Card content"), " ", /*#__PURE__*/_react.default.createElement("p", null, "Card content"), " ", /*#__PURE__*/_react.default.createElement("p", null, "Card content")));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorText', 'colorTextHeading', 'colorTextSecondary', 'colorBgContainer', 'colorBorderSecondary', 'colorPrimary', 'colorBgContainer'],
  key: 'card'
};
var _default = exports.default = componentDemo;